// extracted by mini-css-extract-plugin
export default {"wrapper":"gz-z","addressLine":"hz-z","fullName":"iz-z"};